module.exports = __webpack_public_path__ + "img/adhd-banner-photo.8ed5eb3c.jpg";